import Edition from './Edition'

export default Edition